import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const spinnerClass = size === 'small' ? 'w-6 h-6' : 
                       size === 'large' ? 'w-12 h-12' : 'w-8 h-8';
  
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className={`${spinnerClass} border-4 border-primary/20 border-t-primary rounded-full animate-spin`}></div>
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
